import { AxiosResponse } from "axios";
import { baseURL } from "../core/interceptor/interceptor";
import { getToken } from "./localstorage-helper";

export const downloadFile = (response: AxiosResponse) => {
  const contentDisposition = response.headers["content-disposition"];
  const pattern = /filename\*?=(?:UTF-8'')?([^;]+)/;
  const match = contentDisposition.match(pattern);
  let fileName = "file";
  if (match) fileName = match[1];
  const href = URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href = href;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(href);
};

export const downloadFileTest = (response: AxiosResponse, url: string) => {
  if (response.data !== null && response.data !== "") {
    const tenantName = window.location.pathname.split("/")[1];
    const token = getToken();
    const href = `${baseURL}/${tenantName}/${url}?authorization=${token}&fileId=${response.data}`;
    // const href = `http://localhost:7004/api/Files/Download?authorization=${token}&fileId=${response.data}`;
    // const href = `http://localhost:7008/api/FileDownLoad/2`;
    window.location.href = href;
  }
};

export function objectToFormData<T>(obj: T, parentKey: string = ""): FormData {
  const formData = new FormData();

  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = (obj as Record<string, any>)[key];
      const formKey = parentKey ? `${parentKey}.${key}` : key;

      if (Array.isArray(value)) {
        value.forEach((item, index) => {
          const arrayKey = `${formKey}[${index}]`;
          if (item instanceof Object && !(item instanceof File)) {
            const nestedFormData = objectToFormData(item, arrayKey);
            Array.from(nestedFormData.entries()).forEach(
              ([nestedKey, nestedValue]) => {
                formData.append(nestedKey, nestedValue);
              }
            );
          } else {
            formData.append(arrayKey, item);
          }
        });
      } else if (value instanceof Object && !(value instanceof File)) {
        const nestedFormData = objectToFormData(value, formKey);
        Array.from(nestedFormData.entries()).forEach(
          ([nestedKey, nestedValue]) => {
            formData.append(nestedKey, nestedValue);
          }
        );
      } else if (value !== null && value !== undefined) {
        formData.append(formKey, value);
      }
    }
  }

  return formData;
}
